module.exports = __webpack_public_path__ + "static/media/pattern-grease.529148b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/patterns/pattern-grease.svg
// module id = 1268
// module chunks = 37